import { useEditor } from "@craftjs/core";
import { useEffect, useMemo } from "react";

function hash(str: string) {
    let h = 5381;
    for (let i = 0; i < str.length; i++) h = ((h << 5) + h) ^ str.charCodeAt(i);
    return String(h >>> 0);
}

let lastAppliedKey = "";

const useDeserializeOnce = ({ contentJsonString, pageKey }: { contentJsonString: string; pageKey: string }) => {
    const { actions, query } = useEditor();
    const key = useMemo(() => `${pageKey}:${hash(contentJsonString)}`, [pageKey, contentJsonString]);

    useEffect(() => {
        if (key === lastAppliedKey) return;
        actions.deserialize(JSON.parse(contentJsonString));
        lastAppliedKey = key;
    }, [actions, query, key, contentJsonString]);
};

export default useDeserializeOnce;
